module.exports = __webpack_public_path__ + "img/tatiana.c6d5ccfa.png";